"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metermain = void 0;
exports.metermain = {
    "addresses": {
        "CreateCall": "0xeE10561f3afad4F5f507341470d3aeA4D73FA238",
        "ProxyAdmin": "0x3F1c2aB9cA6b41a82aEb27A97863b53b946D1545",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fb958932b6c40abaf0b5a1ffae73da2",
        "CompoundLens": "0x63428a789a4dDCd5783379beC1D8d865586f2Ef7",
        "FeedPriceOracle": "0xc552E5fcDBc1d9f3E8352961D3A1B62E5E34bd79",
        "WstMTRGOracle": "0x8e25eb53Fdd8816dD2dD7e9A79Faf16943765687",
        "CompLogic": "0x5eE48E2471a8fA4FADDFF7cbb6FA0489D951f9b8",
        "RedemptionManager": "0x2188bA090EfB7d296207F265e5A82d52d10F0122",
        "Timelock": "0xd8Abb5474FB314FcC4C34d634472aef57134242e",
        "Comptroller": "0xcB4cdDA50C1B6B0E33F544c98420722093B7Aa88",
        "CErc20": "0xDBdb12D989B0f490420BA70317FA0B8774128109",
        "suErc20": "0x9a21e426600CB9388fd75307BB248963AD912CFE",
        "JumpRate#1": "0x770dD46929EE92b4DE160a8DDad51145A9FeC5AC",
        "JumpRate#2": "0x938ec0F06ECcD114E719600CAa3682c8EEC50110",
        "JumpRate#3": "0x0e71Ca1d828B33F6cB64E50Dde05e507e4828581",
        "ZeroRate": "0xcBfE44B024f2263B8bfe869A905e124740DEf9EA",
        "sdrUSDC.eth": "0xC211a250FC30122ee107aC9Acf6686110339520f",
        "USDC.eth": "0xd86e243fc0007e6226b07c9a50c9d70d78299eb5",
        "sdrUSDT.eth": "0xaCEDC263FF6De824B38cAeAAC1FD877b1a7344a1",
        "USDT.eth": "0x5fa41671c48e3c951afc30816947126ccc8c162e",
        "sdrMTRG": "0x6Ff2fB3F8F175df0A39C344de81A4aaaB05c49eB",
        "MTRG": "0x228ebbee999c6a7ad74a6130e81b12f9fe237ba3",
        "sdrwstMTRG": "0x318F6863a8c516dF9C5941AEb328A40f15f525F9",
        "wstMTRG": "0xe2de616fbd8cb9180b26fcfb1b761a232fe56717",
        "sdrETH": "0x52e245606Dd37A9addcD2Bb523d319596eB4b851",
        "ETH": "0x983147fb73a45fc7f8b4dfa1cd61bdc7b111e5b6",
        "sdrsuUSD": "0x755A39999FE536Ec327Cb84110383BFc30fd0F4D",
        "suUSD": "0x8BF591Eae535f93a242D5A954d3Cde648b48A5A8",
        "sdrsuETH": "0x21c4123f62CA28c9ceF3dDd1c8ae71EE9a5003aE",
        "suETH": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC.eth",
            "ctokenAddr": "0xC211a250FC30122ee107aC9Acf6686110339520f",
            "underlySym": "USDC.eth",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd86e243fc0007e6226b07c9a50c9d70d78299eb5",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT.eth",
            "ctokenAddr": "0xaCEDC263FF6De824B38cAeAAC1FD877b1a7344a1",
            "underlySym": "USDT.eth",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x5fa41671c48e3c951afc30816947126ccc8c162e",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrMTRG",
            "ctokenAddr": "0x6Ff2fB3F8F175df0A39C344de81A4aaaB05c49eB",
            "underlySym": "MTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x228ebbee999c6a7ad74a6130e81b12f9fe237ba3",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrwstMTRG",
            "ctokenAddr": "0x318F6863a8c516dF9C5941AEb328A40f15f525F9",
            "underlySym": "wstMTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe2de616fbd8cb9180b26fcfb1b761a232fe56717",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x52e245606Dd37A9addcD2Bb523d319596eB4b851",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x983147fb73a45fc7f8b4dfa1cd61bdc7b111e5b6",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x755A39999FE536Ec327Cb84110383BFc30fd0F4D",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x8BF591Eae535f93a242D5A954d3Cde648b48A5A8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x21c4123f62CA28c9ceF3dDd1c8ae71EE9a5003aE",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
            "assetGroupId": 2
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0x770dD46929EE92b4DE160a8DDad51145A9FeC5AC",
            "tokens": [
                "USDC.eth",
                "USDT.eth",
                "ETH"
            ],
            "baseRatePerYear": "0.005",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.65"
        },
        {
            "name": "JumpRate#2",
            "contract": "JumpRateModelV2",
            "address": "0x938ec0F06ECcD114E719600CAa3682c8EEC50110",
            "tokens": [
                "MTRG",
                "wstMTRG"
            ],
            "baseRatePerYear": "0.005",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xcBfE44B024f2263B8bfe869A905e124740DEf9EA",
            "tokens": [
                "suUSD",
                "suETH"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=metermain.js.map